import React from 'react';

/**
 * AIDisclaimer Component
 * A reusable disclaimer component to inform users about AI-generated content
 * 
 * @param {string} variant - Optional variant ('compact' for smaller spaces, default is full)
 * @param {string} message - Optional custom message
 */
function AIDisclaimer({ variant = 'default', message }) {
  const isCompact = variant === 'compact';
  
  const defaultMessage = isCompact 
    ? "AI-generated content may need verification."
    : "This content was generated by AI. Please verify accuracy before using it.";
  
  const displayMessage = message || defaultMessage;
  
  const containerStyle = {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e3e6ea',
    borderLeft: '4px solid #5b9bd5',
    borderRadius: '6px',
    padding: isCompact ? '10px 14px' : '12px 16px',
    margin: '10px 0',
    fontSize: isCompact ? '12px' : '13px',
    color: '#495057',
    lineHeight: '1.5',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    maxWidth: '100%',
    boxSizing: 'border-box'
  };

  return (
    <div style={containerStyle}>
      <strong>Disclaimer:</strong> {displayMessage}
    </div>
  );
}

export default AIDisclaimer;
